export const DURATION = 4000;
export const SWIPE_THRESHOLD = 35;
export const DISMISS_TIMEOUT = 1000;
